// The canonical list of usernames nobody may claim -- the single source
// both the server and the client validate against, so this list can
// never drift into two independently-maintained copies that disagree.
// Same sharing mechanism as socialPlatformRegistry.js (see that file's
// own comment for the full explanation): lives under client/src/ so
// CRA's webpack build can `import` it normally, but plain Node
// (route/api/users.js, route/api/admin.js) `require()`s it directly via
// a relative path with no build step involved -- Node has no
// restriction on requiring files from anywhere on disk, only CRA's own
// ModuleScopePlugin restricts the *client* bundle to files under
// client/src/, and this file already is one. CommonJS (module.exports),
// not an ES module, for the same reason: webpack/Babel's CommonJS
// interop makes `import { RESERVED_USERNAMES } from
// './reservedUsernames'` resolve fine from the client side regardless.
//
// Two sources feed this list:
// - Every top-level path segment App.js's router defines (register,
//   login, admin, etc.) -- a username matching one would make
//   /<username> ambiguous with that route. App.js's own <Switch> puts
//   /admin (a prefix route, not exact) ahead of the catch-all /:id, so
//   a real account with userName "admin" is fully shadowed -- visiting
//   its own profile renders the admin panel instead. That's the bug
//   this list exists to prevent from recurring for any of these paths.
// - A few explicitly reserved beyond that: identity-implying words
//   (admin/owner/console/support/staff/root/system) and names that
//   could be mistaken for this app's own official presence (api, www,
//   settings, dcsinfo, digitalcontacts).
//
// Compared against usernames only after the same normalization
// /update_username already applies (utils/userName.js's
// normalizeUserName -- whitespace-stripped, lowercased), so entries
// here are lowercase with no whitespace.
const RESERVED_USERNAMES = [
  // App.js route segments
  'landing',
  'register',
  'login',
  'add_profile_image',
  'add_socials',
  'bio',
  'reset_password',
  'find_account',
  'enter_code',
  'new_password',
  'claim',
  'terms_and_conditions',
  'privacy_policy',
  'edit_profile',
  'leads',
  'analytics',
  'profile',
  'admin',
  // Explicitly reserved
  'owner',
  'console',
  'support',
  'staff',
  'root',
  'system',
  'api',
  'www',
  'settings',
  'dcsinfo',
  'digitalcontacts',
];

module.exports = { RESERVED_USERNAMES };
